import api from '@/api';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getLeadDistribution() {
      return api.base()
        .get('/lead-distribution')
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateLeadDistribution(actions, {
      mode,
      entries
    }) {
      return api.base()
        .post('/lead-distribution/update', {
          mode,
          entries: (entries || []).map(entry => ({
            orgId: entry.orgId,
            businessUnitId: entry.businessUnitId,
            weight: entry.weight,
            enabled: entry.enabled,
          })),
        })
        .then(
          response => {
            return response.data.data;
          }
        );
    },
  }

};
